import React from 'react';
import {TableHeader} from '../../../components/table/Headers';
import {Table} from '../../../components/table/Table';
import {UserAvatarWithNameAndEmail} from '../../reimbursement/components/ReimbursementColumnRenders';
import {AddButton} from '../../../components/button/AddButton';
import {useInvoke} from '../../../controllers/useInvoke';

const deleteTeamLead = ({invoke}) => ({
  title: 'Delete',
  confirm: {
    title: 'Delete Team Lead',
    message: 'Do you want delete team lead for this data?',
  },
  onPress: props => {
    const {row = {}} = props;
    invoke({
      uri: `/employeeassociations/${row?._id}`,
    });
  },
});

export const EmployeeTeamLeadTable = props => {
  const {
    route: {params},
  } = props;
  const {row} = params;
  const invoke = useInvoke({
    method: 'delete',
    eventSourceId: 'employeeassociation',
  });
  return (
    <Table
      eventSourceId={['employeeassociation']}
      api={`/employeeassociations`}
      fields={{
        skill_leader: {name: 1, color: 1, official_email_id: 1},
        from_date: 1,
        to_date: 1,
      }}
      addOnFilter={{employee: row?._id, skill_leader: {$exists: true}}}
      renderHeader={() => {
        return (
          <TableHeader
            title="Technical lead"
            secondaryTitle={`${row?.name}`}
            actions={[
              <AddButton
                title="Technical Lead"
                view="add-team-leader"
                params={params}
              />,
            ]}
          />
        );
      }}
      columns={[
        {
          header: 'Employee',
          render: ({row}) => {
            return (
              <UserAvatarWithNameAndEmail
                name={row?.skill_leader?.name}
                color={row?.skill_leader?.color}
                official_email_id={row?.skill_leader?.official_email_id}
              />
            );
          },
          minWidth: 200,
        },
        {
          header: 'Start Date',
          field: 'from_date',
          type: 'date',
          formatOptions: {format: 'DD MMM YY'},
        },
        {
          header: 'End Date',
          field: 'to_date',
          type: 'date',
          formatOptions: {format: 'DD MMM YY'},
        },
      ]}
      moreActions={[deleteTeamLead({invoke})]}
    />
  );
};
